"use strict";

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

function init(config) {
  // Config
  var isLocal = window.location.hostname.includes("127.0.0.1");
  var hostname = isLocal
    ? window.location.hostname
    : "." + window.location.hostname;
  var secure = "https:" === window.location.protocol;
  var ddApiBasePath = isLocal
    ? "https://ddapi.development.dietdoctor.com"
    : ckdc.DDAPI;
  var firebaseApiKey = config.apiKey;

  jQuery(".form-message").remove();
  var incorrectLoginMessage = jQuery(
    '<div class="form-message error"><p>' +
      auth.s.incorrectLoginMessage +
      "</p></div>"
  );
  var generalErrorMessage = jQuery(
    '<div class="form-message error">' + auth.s.generalErrorMessage + "</div>"
  );
  var form = jQuery("input[name=ckdc_email]").closest("form");

  // Function for initializing Firebase scripts & SDK
  var firebaseScriptsLoaded = false;
  function loadFirebaseScripts() {
    return new Promise(function (resolve, reject) {
      var firebaseAppScriptElement = document.createElement("script");
      firebaseAppScriptElement.src =
        "/wp-content/themes/ckdc/dist/js/firebase-app.min.js";
      firebaseAppScriptElement.async = false;
      document
        .getElementById("extra-js")
        .insertAdjacentElement("beforebegin", firebaseAppScriptElement);

      var firebaseAuthScriptElement = document.createElement("script");
      firebaseAuthScriptElement.src =
        "/wp-content/themes/ckdc/dist/js/firebase-auth.min.js";
      firebaseAuthScriptElement.async = false;
      document
        .getElementById("extra-js")
        .insertAdjacentElement("beforebegin", firebaseAuthScriptElement);

      var firebaseAppScriptElementReady = new Promise(function (resolve) {
        firebaseAppScriptElement.addEventListener("load", resolve, false);
      });

      var firebaseAuthScriptElementReady = new Promise(function (resolve) {
        firebaseAuthScriptElement.addEventListener("load", resolve, false);
      });

      Promise.all([
        firebaseAppScriptElementReady,
        firebaseAuthScriptElementReady,
      ]).then(function () {
        firebaseScriptsLoaded = true;
        firebase.initializeApp(config);
        resolve(true);
      });
    });
  }

  // Get existing access token
  var authCookieAccessToken = Cookies.get("auth");

  // Check if auth cookie exists
  if (authCookieAccessToken) {
    loadFirebaseScripts().then(function () {
      // Check if user is logged in in Firebase SDK
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          // Refresh access token on page load
          refreshAccessToken().then(function () {
            var oldTokenDecoded = parseJwt(authCookieAccessToken);

            // Check if token is expired
            if (!(Date.now().valueOf() / 1000 < oldTokenDecoded.exp)) {
              window.location.reload(true);
            }
          });
          // Interval for refreshing accessToken
          setInterval(function () {
            refreshAccessToken();
          }, 3300000); // 55 minutes token refresh (1 hr expiration)
        }
      });
    });
  }
  // Login and Signup pages
  else if (
    window.location.pathname.includes("/login") ||
    window.location.pathname.includes("/se/login") ||
    window.location.pathname.includes("/iniciar-sesion") ||
    window.location.pathname.includes("/become-member") ||
    window.location.pathname.includes("/se/bli-medlem") ||
    window.location.pathname.includes("/es/hazte-miembro") ||
    window.location.pathname.includes("/my-account") ||
    window.location.pathname.includes("/es/mi-cuenta") ||
    window.location.pathname.includes("/se/medlem/mitt-konto") ||
    window.location.pathname.includes("/bt-become-member") ||
    window.location.pathname.includes("/es/bt-hazte-miembro") ||
    window.location.pathname.includes("/se/bt-bli-medlem")
  ) {
    loadFirebaseScripts();
  }
  // On dropdown activate
  else {
    jQuery("#header-login-btn").click(function (e) {
      e.preventDefault();

      if (!firebaseScriptsLoaded) {
        loadFirebaseScripts();
      }

      return false;
    });
  }

  // Create account
  function signup(email, password) {
    var payload = {
      firstName: ckdc.NAME_PLACEHOLDER,
      lastName: ckdc.NAME_PLACEHOLDER,
      email: email,
      password: password,
      taxResidence: "",
      country: "",
      language: ckdc.SITE_LANGUAGE,
      communicationPrefs: {
        subscribeMemberEmails: false,
        subscribeNewsletterEmails: false,
      },
    };
    var mutation = "mutation { createUser(user:@) {token} }".replace(
      "@",
      JSON.stringify(payload).replace(/"([^"]+)":/g, "$1:")
    );
    jQuery(".kd-box-warning").remove();

    // GraphQL sign up mutation call
    jQuery.ajax({
      url: ddApiBasePath + "/v1",
      type: "POST",
      crossDomain: true,
      data: JSON.stringify({
        query: mutation,
      }),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      // Before
      beforeSend: function beforeSend() {
        startActivity(jQuery("#_form_checkout-account_submit"));
      },
      // Success
      success: function success(data) {

        if (data.errors) {
            var isConflict = data.errors.some(function (obj) {
                return obj.message.indexOf("email already registered") > -1;
            });

            var isInvalidPass = data.errors.some(function (obj) {
                return obj.message.indexOf("invalid password") > -1;
            });

            var message;

            if (isConflict) {
                message = jQuery(
                    '<div class="kd-box kd-box-warning">' +
                        auth.s.isConflictMessage +
                        "</div>"
                );
            } else if (isInvalidPass) {
                message = jQuery(
                    '<div class="kd-box kd-box-warning">' +
                    auth.s.isInvalidPass +
                    "</div>"
                );
            } else {
                message = jQuery(
                    '<div class="kd-box kd-box-warning">' +
                        auth.s.generalErrorMessage +
                        "</div>"
                );
            }

            jQuery("#_form_checkout-account-user_email")
                .parent()
                .prepend(message);

            return stopActivity();
        }

        login(email, password);
      },
      // Error
      error: function error(_error) {
        console.log("Signup error", _error);

        jQuery("#_form_checkout-account-user_email")
            .parent()
            .prepend(
                jQuery(
                    '<div class="kd-box kd-box-warning">' +
                        auth.s.generalErrorMessage +
                        "</div>"
                )
            );

        stopActivity();
      },
    });
  }

  // Update access token cookie
  function updateAuthCookie(accessToken) {
    Cookies.set("auth", accessToken, {
      domain: hostname,
      secure: secure,
      expires: localStorage.getItem("REMEMBER_ME") == "false" ? undefined : 365,
    });
  }

  // Refresh access token
  function refreshAccessToken() {
    return new Promise(function (resolve, reject) {
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then(function (accessToken) {
          updateAuthCookie(accessToken);
          resolve(accessToken);
        });
    });
  }

  // Login
  function login(email, password) {
    logout().then(function () {
      if (jQuery("input[name=ckdc_rememberme]").prop("checked") == false) {
        localStorage.setItem("REMEMBER_ME", false);
      }

      function getCustomToken(email, password) {
        return new Promise(function (resolve, reject) {
          jQuery.ajax({
            url: ddApiBasePath + "/auth/token",
            type: "POST",
            crossDomain: true,
            data: JSON.stringify({
              userName: email,
              password: password,
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            // Success
            success: function success(data) {
              resolve(data.token);
            },
            // Error
            error: function error(_error2) {
              if (_error2.status == 401) {
                // 401 incorrect login details
                form.prepend(incorrectLoginMessage);
              } else {
                // anything else show general error
                form.prepend(generalErrorMessage);
              }

              reject(_error2);
            },
          });
        });
      }

      startActivity(jQuery("button[name=login]"));

      // Execute functions
      getCustomToken(email, password)
        .then(function (customToken) {
          firebase
            .auth()
            .setPersistence(
              jQuery("input[name=ckdc_rememberme]").prop("checked") == false
                ? firebase.auth.Auth.Persistence.SESSION
                : firebase.auth.Auth.Persistence.LOCAL
            )
            .then(function () {
              firebase
                .auth()
                .signInWithCustomToken(customToken)
                .then(function (userCredential) {
                  userCredential.user
                    .getIdToken(false)
                    .then(function (accessToken) {
                      updateAuthCookie(accessToken);

                      var redirect_to = new URLSearchParams(
                        window.location.search
                      ).get("redirect_to");

                      if (redirect_to) {
                        window.location.href = redirect_to;
                      } else {
                        window.location.reload(true);
                      }

                    });
                })
                ["catch"](function (error) {
                  throw error;
                });
            })
            ["catch"](function (error) {
              throw error;
            });
        })
        ["catch"](function (error) {
          console.log("Firebase login error: ", error);
          stopActivity();
        });
    });
  }

  // Remove cookies & local storage keys
  function logout() {
    return new Promise(function (resolve) {
      // Remove access token cookie
      Cookies.remove("auth", {
        domain: hostname,
        secure: secure,
      });

      // New Gatsby frontend local storage keys
      localStorage.removeItem("DIETDOCTOR_USERID");
      localStorage.removeItem("DIETDOCTOR_LEGACY_USERID");
      localStorage.removeItem("DIETDOCTOR_USER_INFO");
      localStorage.removeItem("DIETDOCTOR_TOKEN"); // "Remember me" checkbox

      localStorage.removeItem("REMEMBER_ME");

      // Logout from Firebase SDK
      firebase
        .auth()
        .signOut()
        .then(function () {
          if (ckdc.logout_nonce) {
            jQuery.getJSON(ckdc.ajaxurl, {
              action: "auth_logout",
              logout_nonce: ckdc.logout_nonce,
            });
          }
          resolve(true);
        })
        ["catch"](function (error) {
          console.log("Logout error: ", error);
          resolve(false);
        });
    });
  }

  ckdc.logout = logout;

  // Loading indicator start
  function startActivity(trigger) {
    stopActivity();
    var spinner = jQuery(
      '<i class="fa fa-spinner" data-spinner aria-hidden="true" style="animation: spin 1s linear infinite;"></i><style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}</style>'
    );
    trigger.data("text", trigger.html());
    trigger.html(spinner);
    trigger.prop("disabled", true);
  }

  // Loading indicator Stop
  function stopActivity() {
    var spinners = jQuery("[data-spinner]").each(function (idx, spinner) {
      spinner = jQuery(spinner);
      var parent = spinner.parent();
      parent.html(parent.data("text"));
      parent.prop("disabled", false);
      spinner.remove();
    });
  }

  // Check validity of a field
  function valid(field, message) {
    var parent = field.parent();
    parent.find(".error-msg").remove();
    parent.removeClass("error");
    var validity = field[0].checkValidity();

    if (!validity) {
      parent.append('<div class="error-msg">' + message + "</div>");
      parent.addClass("error");
    }

    return validity;
  }

  // Event listeners
  function attachHandlers() {
    // Login
    function setupLogin() {
      function handleLoginTrigger(event) {
        var form = jQuery(event.target).closest("form");
        var emailTextBox = form.find("input[name=ckdc_email]");
        var passwordTextBox = form.find("input[name=ckdc_password]");

        if (
          valid(emailTextBox, ckdc.s.login_empty_email) &&
          valid(passwordTextBox, ckdc.s.login_empty_password)
        ) {
          startActivity(jQuery("button[name=login]"));
          login(emailTextBox.val().toLowerCase(), passwordTextBox.val());
        }

        return false;
      }

      jQuery("button[name=login]").on("click", function (event) {
        event.preventDefault();
        return handleLoginTrigger(event);
      });
      jQuery("form.logins").on("keypress", function (event) {
        if (event.which == 13) {
          event.preventDefault();
          return handleLoginTrigger(event);
        }
      });
    }

    // Sign up setup
    function setupSignup() {
      var button = jQuery("#_form_checkout-account_submit");
      var emailTextBox = jQuery("#_form_checkout-account-user_email");
      var passwordTextBox = jQuery("#_form_checkout-account-user_pass");
      var form = jQuery("#_form_checkout-account");
      emailTextBox.attr("required", true);
      passwordTextBox.attr("required", true);

      /* Hack to turn old button into <button> for consistency */
      var newButton = jQuery(
        '<button type="button" id="_form_checkout-account_submit" class="btn form-btn btn-submit dd-member-signup-checkout-account gold ckdc-start-working">' +
          auth.s["continue"] +
          "</button>"
      );
      button.replaceWith(newButton);
      form.attr("onsubmit", "return false");

      function handleSignupTrigger() {
        var validEmail = valid(emailTextBox, ckdc.s.login_empty_email);
        var validPassword = valid(passwordTextBox, ckdc.s.login_empty_password);

        if (!validEmail || !validPassword) {
          return false;
        }

        startActivity(jQuery("#_form_checkout-account_submit"));
        signup(emailTextBox.val().toLowerCase(), passwordTextBox.val());
        return false;
      }

      newButton.on("click", function (event) {
        event.preventDefault();
        return handleSignupTrigger();
      });
      form.on("keypress", function (event) {
        if (event.which == 13) {
          event.preventDefault();
          return handleSignupTrigger();
        }
      });
    }

    // Logout setup
    function setupLogout() {
      jQuery("#menu-logout-link").on("click", function (event) {
        event.preventDefault();
        logout().then(function () {
          window.location.reload(true);
        });
      });
    }

    setupLogin();
    setupSignup();
    setupLogout();
  }

  attachHandlers();
}

ckdc.ready(function () {
  jQuery.getJSON(
    "/wp-content/themes/ckdc/src/js/fb/config.json",
    function (fbConfig) {
      init(fbConfig);
    }
  );
});
